import dateTimeHelper from '../../../Helpers/datetimeHelper';

export default class ProjectPlatformCostOverrideItem {
  constructor(item, project) {
    if (item === undefined || item === null || !item.projectPlatformCostOverrideId) {
      this.ProjectPlatformCostOverrideId = '';
      this.ProjectId = project ? project.ProjectId : '';
      this.ProjectName = project ? project.ProjectName : '';
      this.AmountUsd = '';
      this.EffectiveFromDate = dateTimeHelper.firstDayOfTheActualMonth();
      this.EndDate = dateTimeHelper.indefiniteDateValue();
      this.IsNewOverride = true;
      return;
    }

    this.ProjectPlatformCostOverrideId = item.projectPlatformCostOverrideId;
    this.ProjectId = item.projectId;
    this.ProjectName = project ? project.ProjectName : '';
    this.AmountUsd = item.amountUsd;
    this.EffectiveFromDate = item.effectiveFromDate;
    this.EndDate = item.endDate ?? dateTimeHelper.indefiniteDateValue();
    this.IsNewOverride = false;
  }
}
